<template>
  <b-modal
    id="viewalljddetails"
    :visible="showAllDetailsJD"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="hideAllJobDetailsModal(), (advance = false)"
  >
    <div>
      <div
        class="
          newpanlog-rs-mainhead
          pl-2
          pr-2
          pb-3
          d-flex
          align-items-center
          justify-content-between
        "
      >
        Job Details
      </div>
      <div
        class="rotate-on-hover xmark-pos"
        @click="hideAllJobDetailsModal(), (advance = false)"
      >
        <img src="../../../assets/panelist/blue_cross.svg" alt="" />
      </div>
      <hr class="hr-jd" />
      <div v-if="jdDetailsType != 1" class="jdd-container-outer">
        <template v-if="localAllDetailDropDowns === 'openBasic'">
          <div class="basic-jdd-container ml-1 mr-1 mt-2">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                w-100
                jd-modal
                pointer
              "
              @click="openDropDownJDModal('close')"
            >
              <div class="close-box-txt">Basic Details</div>
              <div>
                <img src="../../../assets/panelLog/up_arrow.svg" alt="" />
              </div>
            </div>

            <div class="panlog-jobdeatils py-2 px-3 mb-2">
              <div
                v-for="(field, index) in filteredFields(basicArray)"
                :key="field.key + index"
              >
                <div class="panlog-right-deatils-heading mt-7px">
                  {{ field.label }}
                </div>
                <div class="panlog-right-detail-subheads">
                  <div v-if="checkFieldKeys(field)">-</div>
                  <div
                    style="word-break: keep-all"
                    v-else-if="Object.keys(panelJdDetails).length > 0"
                  >
                    <template v-if="isHtmlContent(field)">
                      <div v-html="checkValuesOfKey(field)"></div>
                    </template>
                    <template v-else>
                      {{ checkValuesOfKey(field) }}
                    </template>
                  </div>
                  <div
                    v-if="
                      !checkFieldKeys(field) &&
                      field.controlType == 'upload_file'
                    "
                    class="pointer"
                  >
                    <img
                      @click="downloadFile(field)"
                      class="ml-2"
                      src="../../../assets/talentpool/tp_download_vc.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div class="mt-3" v-if="filteredFields(advanceArray).length">
                <div
                  class="d-flex align-items-center pointer"
                  @click="advance = !advance"
                >
                  <img
                    v-if="advance == false"
                    src="../../../assets/panelLog/advance.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/panelLog/advance-down.svg"
                    alt=""
                  />

                  <span class="panlog-advance-text ml-2 mr-2 pointer"
                    >Advanced</span
                  >
                  <hr />
                </div>
              </div>

              <div v-if="advance">
                <div
                  v-for="(field, index) in filteredFields(advanceArray)"
                  :key="field.key + index"
                >
                  <div class="panlog-right-deatils-heading mt-7px">
                    {{ field.label }}
                  </div>
                  <div class="panlog-right-detail-subheads">
                    <div v-if="checkFieldKeys(field)">-</div>
                    <div
                      style="word-break: keep-all"
                      v-else-if="Object.keys(panelJdDetails).length > 0"
                    >
                      <template v-if="isHtmlContent(field)">
                        <div v-html="checkValuesOfKey(field)"></div>
                      </template>
                      <template v-else>
                        {{ checkValuesOfKey(field) }}
                      </template>
                    </div>
                    <div
                      v-if="
                        !checkFieldKeys(field) &&
                        field.controlType == 'upload_file'
                      "
                      class="pointer"
                    >
                      <img
                        @click="downloadFile(field)"
                        class="ml-2"
                        src="../../../assets/talentpool/tp_download_vc.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div
            class="
              basic-close
              d-flex
              align-items-center
              justify-content-between
              ml-1
              mr-1
              mt-2
              pointer
            "
            @click="openDropDownJDModal('openBasic')"
          >
            <div class="close-box-txt">Basic Details</div>
            <div>
              <img src="../../../assets/panelLog/down_arrow.svg" alt="" />
            </div>
          </div>
        </template>

        <template v-if="localAllDetailDropDowns === 'openIP'">
          <div class="ml-1 mr-1 mt-2 basic-jdd-container">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                w-100
                jd-modal
                pointer
              "
              @click="openDropDownJDModal('close')"
            >
              <div class="close-box-txt">Interview Process</div>
              <div>
                <img src="../../../assets/panelLog/up_arrow.svg" alt="" />
              </div>
            </div>
            <div class="panlog-ip-container mt-2">
              <div class="intpro-head">Interview Rounds</div>
              <div
                class="mt-4 d-flex w-100"
                v-for="(i, index) in selectedJDProcess"
                :key="index"
              >
                <div class="position-relative">
                  <div class="panlog-ip-side-circle"></div>
                  <div
                    v-if="index < selectedJDProcess.length - 1"
                    class="panlog-ip-side-line"
                  ></div>
                </div>
                <div class="d-flex justify-content-between ml-3 w-100">
                  <div>
                    <div class="panlog-ip-main-head">
                      Round {{ index + 1 }} -
                      {{ i.type === "f2f" ? "Face to face" : "Assessment" }}
                    </div>
                    <div class="panlog-ip-sub-head">{{ i.name }}</div>
                  </div>
                  <div>
                    <img
                      v-if="i.type === 'assesment'"
                      src="../../../assets/panelLog/ipasmntround.svg"
                      alt=""
                    />
                    <img
                      v-else-if="i.type === 'f2f'"
                      src="../../../assets/panelLog/f2fimg.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div
            class="
              basic-close
              d-flex
              align-items-center
              justify-content-between
              ml-1
              mr-1
              mt-2
              pointer
            "
            @click="openDropDownJDModal('openIP')"
          >
            <div class="close-box-txt">Interview Process</div>
            <div>
              <img src="../../../assets/panelLog/down_arrow.svg" alt="" />
            </div>
          </div>
        </template>

        <template v-if="localAllDetailDropDowns === 'openRecPan'">
          <div class="ml-1 mr-1 mt-2 basic-jdd-container mb-3">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                w-100
                jd-modal
                pointer
              "
              @click="openDropDownJDModal('close')"
            >
              <div class="close-box-txt">Allocated</div>
              <div>
                <img src="../../../assets/panelLog/up_arrow.svg" alt="" />
              </div>
            </div>
            <div class="p-2 overflow-auto">
              <div class="createjobs-viewjd-recbox">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="allocate-head-txt">Recruiters</div>
                </div>
                <div class="mt-2">
                  <div
                    class="d-flex align-items-center flex-wrap gap-15"
                    v-if="panelJdDetails.assignedTo.length == 0"
                  >
                    <div class="hint-txt-allocate mt-2">
                      No recruiters are allocated
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center flex-wrap gap-15"
                    v-else
                  >
                    <div
                      class="allocate-boxes text-break allocate-boxes-txt"
                      v-for="(rec, index) in panelJdDetails.assignedTo"
                      :key="index"
                    >
                      {{ rec.username }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="createjobs-viewjd-recbox">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="allocate-head-txt">Panelists</div>
                </div>

                <div
                  class="hint-txt-allocate mt-2"
                  v-if="
                    panelJdDetails.showAllPanelist == true &&
                    panelJdDetails.assignedPanelist.length == 0
                  "
                >
                  All panelists are allocated for this JD
                </div>
                <!-- use below line if there are no panel list same goes to recruiters and vendors -->
                <div
                  class="hint-txt-allocate mt-2"
                  v-else-if="
                    panelJdDetails.showAllPanelist == false &&
                    panelJdDetails.assignedPanelist.length == 0
                  "
                >
                  No panelists are allocated
                </div>
                <div
                  class="d-flex align-items-center flex-wrap gap-15 mt-2"
                  v-else-if="
                    panelJdDetails.showAllPanelist == false &&
                    panelJdDetails.assignedPanelist.length != 0
                  "
                >
                  <div
                    class="allocate-boxes allocate-boxes-txt"
                    v-for="(pan, index) in panelJdDetails.assignedPanelist"
                    :key="index"
                  >
                    {{ pan.username }}
                  </div>
                </div>
              </div>

              <div class="createjobs-viewjd-recbox">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="allocate-head-txt">Vendors</div>
                </div>
                <div
                  class="hint-txt-allocate mt-2"
                  v-if="panelJdDetails.vendor.length == 0"
                >
                  No vendors are allocated
                </div>
                <div
                  class="d-flex align-items-center flex-wrap gap-15 mt-2"
                  v-else
                >
                  <div
                    class="allocate-boxes allocate-boxes-txt"
                    v-for="(vendor, index) in panelJdDetails.vendor"
                    :key="index"
                  >
                    {{ vendor.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div
            class="
              basic-close
              d-flex
              align-items-center
              justify-content-between
              ml-1
              mr-1
              mt-2
              pointer
              mb-3
            "
            @click="openDropDownJDModal('openRecPan')"
          >
            <div class="close-box-txt">Allocated</div>
            <div>
              <img src="../../../assets/panelLog/down_arrow.svg" alt="" />
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="jdDetailsType == 1"
        class="jdd-container-outer panlog-jobdeatils py-2 px-3 mb-2"
      >
        <div
          v-for="(field, index) in filteredFields(basicArray)"
          :key="field.key + index"
        >
          <div class="panlog-right-deatils-heading mt-7px">
            {{ field.label }}
          </div>
          <div class="panlog-right-detail-subheads">
            <div v-if="checkFieldKeys(field)">-</div>
            <div
              style="word-break: keep-all"
              v-else-if="Object.keys(panelJdDetails).length > 0"
            >
              <template v-if="isHtmlContent(field)">
                <div v-html="checkValuesOfKey(field)"></div>
              </template>
              <template v-else>
                {{ checkValuesOfKey(field) }}
              </template>
            </div>
            <div
              v-if="
                !checkFieldKeys(field) && field.controlType == 'upload_file'
              "
              class="pointer"
            >
              <img
                @click="downloadFile(field)"
                class="ml-2"
                src="../../../assets/talentpool/tp_download_vc.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../../utils/customFields";
import { downloadAnyFile } from "../../../utils/apiFunctions.js";
export default {
  name: "JobDetails",
  data() {
    return {
      isLaptop: true,
      advance: false,
      localAllDetailDropDowns: this.allDetailDropDowns,
    };
  },

  props: {
    jdDetailsType: Number,
    panelJdDetails: Object,
    allDetailDropDowns: String,
    showAllDetailsJD: Boolean,
    basicArray: Array,
    advanceArray: Array,
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  computed: {
    selectedJDProcess() {
      // Define an array of invalid rounds
      const invalidRounds = [0, "F", "H", "R", "NI"];

      // Access panelJdDetails and filter out invalid processes
      return (
        this.panelJdDetails.interviewProcess?.process.filter(
          (process) => !invalidRounds.includes(process.id)
        ) || []
      );
    },
  },
  methods: {
    filteredFields(fields) {
      let custFields = JSON.parse(JSON.stringify(fields));
      let field = custFields.find((obj) => obj.key == "documents");
      if (field) {
        let docRequired = checkValuesOfKey(field, this.panelJdDetails);
        if (docRequired == "No") {
          custFields = custFields.filter(
            (obj) => obj.key != "requiredDocumets"
          );
        }
      }
      let roleField = custFields.find((obj) => obj.key == "role");
      if (roleField) {
        let roleValue = checkValuesOfKey(roleField, this.panelJdDetails);
        if (roleValue != "Others") {
          custFields = custFields.filter((obj) => obj.key != "otherRole");
        }
      }
      return custFields;
    },
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    openDropDownJDModal(flag) {
      this.localAllDetailDropDowns = flag;
    },
    hideAllJobDetailsModal() {
      this.$emit("hideAllJobDetailsModal");
    },
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.panelJdDetails);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.panelJdDetails);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.panelJdDetails);
    },
    async downloadFile(field) {
      let payload;
      if (field.fieldType != "default") {
        payload = this.candidateData.customFields[field.key];
      } else {
        payload = this.candidateData[field.key];
      }
      const res = await downloadAnyFile(payload);
      if (res.status == 200) {
        const link = res.data.data.downloadLink;
        // implemented bcz once we click on download resume that page shouldn't go blank
        const candidateName = res.data.data.name;

        // Create a dynamic file name based on the candidate's name and email
        const fileName = `${candidateName}_${field.label}.pdf`;

        // Create an anchor element
        const a = document.createElement("a");
        a.href = link;
        a.download = fileName; // Set the dynamically generated file name

        // Trigger a click event on the anchor element
        a.click();
        // this.successModal("Resume downloaded successfully");
      }
    },
  },
};
</script>
